import { useEffect, useState } from 'react';
import { getAllPartsListRequest } from './allPartsRequest';

let cachedPartsList = null;
let pendingRequest = null;

const useAllPartsList = () => {
  const [partsList, setPartsList] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchMatters = async () => {
      if (Array.isArray(cachedPartsList)) {
        if (mounted) {
          setPartsList(cachedPartsList);
        }
        return;
      }

      if (!pendingRequest) {
        pendingRequest = getAllPartsListRequest();
      }

      const list = await pendingRequest;
      cachedPartsList = Array.isArray(list) ? list : [];
      pendingRequest = null;

      if (mounted) {
        setPartsList(cachedPartsList);
      }
    };

    fetchMatters();

    return () => {
      mounted = false;
    };
  }, []);

  return partsList;
};

export default useAllPartsList;
